
const common = {
  nav: {
    home: '首页',
    about: '关于我们',
    products: '产品',
    solutions: '解决方案',
    contact: '联系我们',
    privacy: '隐私政策',
    terms: '服务条款'
  },
  footer: {
    company: '公司',
    products: '产品',
    support: '支持',
    legal: '法律',
    contact: '联系我们',
    email: 'business@deriway.com',
    telegram: '@deriway_business',
    copyright: '版权所有。',
    poweredBy: 'Powered by Readdy',
    quickLinks: '快速链接',
    legalSupport: '法律与支持',
    newsletter: '订阅我们的资讯',
    newsletterDesc: '获取最新的金融科技动态和产品更新',
    emailPlaceholder: '请输入您的邮箱地址',
    subscribe: '订阅',
    partners: '合作伙伴与认证'
  },
  buttons: {
    learnMore: '了解更多',
    getStarted: '开始使用',
    contactUs: '联系我们',
    submit: '提交',
    cancel: '取消',
    close: '关闭'
  }
};

export default common;